<val-carte-dashboard [titre]="'dashboard.carte-podium-motifs-retour.titre' | transloco" [colonnes]="6" [lignes]="2"
	[chargementEnCours]="chargementEnCours" [estEnErreur]="estEnErreur" [estVide]="estVide">

	<ng-template>
	@if (donnees)
	{
	<div class="podium-conteneur">
		@for (motif of motifsOrdonnesPodium; track motif.rang)
		{
		<div class="podium-colonne">
			<span class="podium-libelle" [title]="motif.libelle">{{ motif.libelle }}</span>
			<div class="podium-bloc rang-{{motif.rang}}">
				<div class="podium-badge">
					<div class="podium-badge-valeur">{{ motif.rang }}</div>
				</div>
				<span class="podium-pourcentage">{{ motif.pourcentageSurTotal | number:'1.0-0' }}%</span>
			</div>
		</div>
		}
	</div>
	}
	</ng-template>

</val-carte-dashboard>
